export default __webpack_public_path__ + "static/media/tick.5a3dbc87.svg";